/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgSpareParts32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M24 12.5h3v7h-3v4H5.5v-15H24v4z'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M5.5 22.5V24l3.035 2.191c.407.294.896.452 1.399.452h9.303a2.39 2.39 0 001.305-.388L24 24v-1'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M30.5 10.5h-2.1a1.4 1.4 0 00-1.4 1.4v8.2a1.4 1.4 0 001.4 1.4h2.1v-11zM15.5 5.357h-5L8.5 8.5h8.833L15.5 5.357z'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M1.5 8.5v15M5.25 15.5h-3M9.559 13.649h5.048M9.559 18h10.94'
      />
    </svg>
  );
}

export default SvgSpareParts32;
